type TranslateFn = (key: string) => string;

export function resolveProductCategoryKey(
  translate: TranslateFn,
  productCategory: string | undefined,
  baseKey: string
): string {
  if (productCategory) {
    const specificKey = `${baseKey}.${productCategory}`;
    if (translate(specificKey) !== specificKey) return specificKey;
  }
  return `${baseKey}.default`;
}



// WEBPACK FOOTER //
// ./ts/app/shared/helpers/resolve-product-category-key.ts